export default __webpack_public_path__ + "static/media/delete-default.2df373e1.svg";